<div style="display:flex;height:100%;margin-top:-8px;">
  <!--playlist directory-->
  <div class="navigation-bar">
    <!--
    <div style="display:flex; justify-content:flex-start;align-items:center;font-weight:bold;margin-">
      <span class="material-icons">account_circle</span> {{userName}} <small>{{siteName}}</small>
    </div>

    <div style="display:flex; justify-content:flex-start;align-items:center;font-weight:bold;margin-">
      <span class="material-icons">home</span> Training Portal
    </div> -->
    <ul class="mdc-list">
      <li class="mdc-list-item"
        style="padding:8px 16px;font-size:16px;font-weight:bold;margin-top:16px;"
        tabindex="-1"
        (click)="selectedController = null">
        <span class="mdc-list-item__ripple"></span>
        <span class="material-icons">playlist_play</span> My Playlists
      </li>
      @for (controller of playlistControllersSorted; track controller) {
        <li class="mdc-list-item"
          style="padding:8px 16px;font-size:14px;"
          tabindex="-1"
          [attr.key]="controller"
          (click)="navigateToPlaylist(controller.playlist.customerPlaylistGuid)">
          <span class="mdc-list-item__ripple"></span>
          <span class="mdc-list-item__text clip" style="flex:1;">{{controller.playlist.title}}</span>
          @if (controller.synchronizationStatus.percentComplete === 100) {
            <i
              style="color:#1976d2;"
            class="material-icons mdc-chip__icon mdc-chip__icon--leading">offline_bolt</i>
          }
        </li>
      }
    </ul>
  </div>
  @if (selectedController) {
    <div class="playlists" style="display:flex;width:100%;height:min-content;">
      @for (controller of [selectedController]; track controller) {
        <div [attr.key]="controller" class="playlist" style="flex:1;height:min-content;">
          <div class="details">
            <div class="playlist-title clamp-1" [attr.aria-label]="controller.playlist.title">
              {{controller.playlist.title}}
              <!-- playlist actions drop down list -->
              <span class="sectionList">
                <i style="position:absolute;top:4px;right:4px;color:#808080;" tabindex="1" class="material-icons mdc-icon-button" aria-label="Sync Playlist">more_vert</i>
                <ul class="mdc-list">
                  <li class="mdc-list-item" tabindex="-1" (click)="navigateToPlaylist(controller.playlist.customerPlaylistGuid)">
                    <span class="mdc-list-item__ripple"></span>
                    <span class="mdc-list-item__text"><span class="material-icons">play_circle</span>Play</span>
                  </li>
                  @if (controller.synchronizationStatus.percentComplete !== 100) {
                    <li class="mdc-list-item" tabindex="-1" (click)="syncPlaylist(controller)">
                      <span class="mdc-list-item__ripple"></span>
                      <span class="mdc-list-item__text"><span class="material-icons">cloud_download</span>Download Playlist</span>
                    </li>
                  }
                  @if (controller.synchronizationStatus.percentComplete === 100) {
                    <li class="mdc-list-item" tabindex="-1" (click)="deletePlaylist(controller)">
                      <span class="mdc-list-item__ripple"></span>
                      <span class="mdc-list-item__text"><span class="material-icons">delete</span>Delete Playlist</span>
                    </li>
                  }
                  <li class="mdc-list-item" tabindex="-1" (click)="selectedController = null">
                    <span class="mdc-list-item__ripple"></span>
                    <span class="mdc-list-item__text"><span class="material-icons">close</span>Close</span>
                  </li>
                </ul>
              </span>
            </div>
            <div class="program-title clamp-1">{{controller.playlist.coreProgramTitle}}</div>
          </div>
          <div class="playlist-details">
            <div class="playlist-contents" style="flex:1;text-align:left;padding:16px;">
              <h3 style="margin-top:0px;color:#0c66be;">Playlist Contents</h3>
              <div style="margin-left:16px;">
                @if (controller.playlist.sections.length > 1) {
                  <ol>
                    @for (section of controller.playlist.sections; track section) {
                      <li [attr.key]="section">{{section.title}}
                        <ul>
                          @for (lesson of section.lessons; track lesson) {
                            <li [attr.key]="lesson">{{lesson.title}}
                              <ul>
                                @for (lessonUnit of lesson.lessonUnits; track lessonUnit) {
                                  <li [attr.key]="lessonUnit">
                                    {{lessonUnit.title}}
                                  </li>
                                }
                              </ul>
                            </li>
                          }
                        </ul>
                      </li>
                    }
                  </ol>
                }
                @if (controller.playlist.sections.length === 1) {
                  <ol>
                    @for (lesson of controller.playlist.sections[0].lessons; track lesson) {
                      <li [attr.key]="lesson">{{lesson.title}}
                        <ul>
                          @for (lessonUnit of lesson.lessonUnits; track lessonUnit) {
                            <li [attr.key]="lessonUnit">
                              {{lessonUnit.title}}
                            </li>
                          }
                        </ul>
                      </li>
                    }
                  </ol>
                }
              </div>
            </div>
            <div style="flex:1;">
              <!--playlist bottom details and actions-->
              <div class="details" style="padding:0px 16px;">
                @if (controller.synchronizationStatus.status !== 'ready') {
                  <div class="download-notice">
                    <div style="flex:1;display:flex;width:100%"><div style="flex:1;text-align:left">Download Progress: {{controller.synchronizationStatus.percentComplete}}%</div><div><span style="cursor:pointer;margin-top:-4px;" class="material-icons">close</span></div></div>
                    <div style="height:100%;width:100%;background-color:#cfcfcf;border-radius:6px;overflow:hidden;">
                      <div class="progress animateDefault"
                        [style.width.%]="controller.synchronizationStatus.percentComplete"
                      [style.background-color]="'#1976d2'"></div>
                    </div>
                  </div>
                }
              </div>
              <!--play video-->
              <div style="margin:0px 16px; padding:0px;border-radius:6px;" class="playlist-image" (click)="navigateToPlaylist(controller.playlist.customerPlaylistGuid)">
                <div class="thumbnail-overlay"><span class="material-icons">play_circle</span></div>
                <img class="thumbnail" style="border-radius:6px;width:100%;" [src]="parseSsl(controller.playlistThumbnailUrl)" />
              </div>
              <div class="details">
                <div class="program-actions">
                  <!-- <div class="action" @click="navigateToPlaylist(controller.playlist.customerPlaylistGuid)">Play <span class="material-icons">play_arrow</span></div>   -->
                  <div class="mdc-chip-set" role="grid" style="position:relative;justify-content:flex-end;">
                    <!--Last Updated-->
                    <div class="mdc-chip" role="row">
                      <div class="mdc-chip__ripple"></div>
                      <i class="material-icons mdc-chip__icon mdc-chip__icon--leading">event</i>
                      <span role="gridcell"><span role="button" tabindex="0" class="mdc-chip__primary-action"><span class="mdc-chip__text">Last Update: {{controller.playlist.lastUpdatedDateTime | date:'MM/dd/yyyy'}}</span></span></span>
                    </div>
                    <!--offline N/A-->
                    @if (controller.synchronizationStatus.percentComplete !== 100) {
                      <div class="mdc-chip" role="row">
                        <div class="mdc-chip__ripple"></div>
                        <i class="material-icons mdc-chip__icon mdc-chip__icon--leading disabled">block</i>
                        <span role="gridcell"><span role="button" tabindex="0" class="mdc-chip__primary-action"><span class="mdc-chip__text disabled">Offline Ready</span></span></span>
                      </div>
                    }
                    <!--offline ready-->
                    @if (controller.synchronizationStatus.percentComplete === 100) {
                      <div class="mdc-chip"  role="row">
                        <div class="mdc-chip__ripple"></div>
                        <i style="color:#1976d2;" class="material-icons mdc-chip__icon mdc-chip__icon--leading">offline_bolt</i>
                        <span role="gridcell"><span role="button" tabindex="0" class="mdc-chip__primary-action"><span class="mdc-chip__text">Offline Ready</span></span></span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (!selectedController) {
    <div class="playlists">
      @for (controller of playlistControllers; track controller) {
        <div [attr.key]="controller" class="playlist">
          <div class="details">
            <div class="playlist-title clamp-1" [attr.aria-label]="controller.playlist.title">
              {{controller.playlist.title}}
              <!-- playlist actions drop down list -->
              <span class="sectionList">
                <i style="position:absolute;top:4px;right:4px;color:#808080;" tabindex="1" class="material-icons mdc-icon-button" aria-label="Sync Playlist">more_vert</i>
                <ul class="mdc-list">
                  <li class="mdc-list-item" tabindex="-1" (click)="selectedController = controller">
                    <span class="mdc-list-item__ripple"></span>
                    <span class="mdc-list-item__text"><span class="material-icons">read_more</span>Details</span>
                  </li>
                  @if (controller.synchronizationStatus.percentComplete !== 100) {
                    <li class="mdc-list-item" tabindex="-1" (click)="syncPlaylist(controller)">
                      <span class="mdc-list-item__ripple"></span>
                      <span class="mdc-list-item__text"><span class="material-icons">cloud_download</span>Download Playlist</span>
                    </li>
                  }
                  @if (controller.synchronizationStatus.percentComplete === 100) {
                    <li class="mdc-list-item" tabindex="-1" (click)="deletePlaylist(controller)">
                      <span class="mdc-list-item__ripple"></span>
                      <span class="mdc-list-item__text"><span class="material-icons">delete</span>Delete Playlist</span>
                    </li>
                  }
                </ul>
              </span>
            </div>
            <div class="program-title clamp-1">{{controller.playlist.coreProgramTitle}}</div>
          </div>
          <div class="playlist-image" (click)="navigateToPlaylist(controller.playlist.customerPlaylistGuid)">
            <div class="thumbnail-overlay"><span class="material-icons">play_circle</span></div>
            <div class="thumbnail" [style.background-image]="'url(' + parseSsl(controller.playlistThumbnailUrl) + ')'" ></div>
          </div>
          <!--playlist bottom details and actions-->
          <div class="details">
            @if (controller.synchronizationStatus.status !== 'ready') {
              <div class="download-notice">
                <div style="flex:1;display:flex;width:100%">
                  <div style="flex:1;text-align:left">Download Progress: {{controller.synchronizationStatus.percentComplete}}%</div>
                  <div><span style="cursor:pointer;margin-top:-4px;" class="material-icons">close</span></div>
                </div>
                <div style="height:100%;width:100%;background-color:#cfcfcf;border-radius:6px;overflow:hidden;">
                  <div class="progress animateDefault"
                    [style.width.%]="controller.synchronizationStatus.percentComplete"
                  [style.background-color]="'#1976d2'"></div>
                </div>
              </div>
            }
            <div class="program-actions">
              <div class="action" (click)="navigateToPlaylist(controller.playlist.customerPlaylistGuid)">Play <span class="material-icons">play_arrow</span></div>
              <div class="mdc-chip-set" role="grid">
                @if (controller.synchronizationStatus.percentComplete !== 100) {
                  <div class="mdc-chip" role="row">
                    <div class="mdc-chip__ripple"></div>
                    <i class="material-icons mdc-chip__icon mdc-chip__icon--leading disabled">block</i>
                    <span role="gridcell"><span role="button" tabindex="0" class="mdc-chip__primary-action"><span class="mdc-chip__text disabled">Offline Ready</span></span></span>
                  </div>
                }
                @if (controller.synchronizationStatus.percentComplete === 100) {
                  <div class="mdc-chip" role="row">
                    <div class="mdc-chip__ripple"></div>
                    <i style="color:#1976d2;" class="material-icons mdc-chip__icon mdc-chip__icon--leading">offline_bolt</i>
                    <span role="gridcell"><span role="button" tabindex="0" class="mdc-chip__primary-action"><span class="mdc-chip__text">Offline Ready</span></span></span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>